// Author Lin
// Date 2021-11-20 12:04:32

class MintalMesPrdSmeltingPelletFeeding {
        constructor({
                id = null,
                locationId = '',
                locationName = '',
                shiftId = '',
                shiftName = '',
                furnaceId = '',
                furnaceName = '',
                feed1 = '',
                feed2 = '',
                feed3 = '',
                feed4 = '',
                feed5 = '',
                feed6 = '',
                feed7 = '',
                feed8 = '',
                feed9 = '',
                shiftTotal = '',
                dailyTotal = '',
                tubeTotal = '',
                beltWeigherNumber = '',
                recordTime = '',
                recorderId = '',
                recorder = '',
                reviewerId = '',
                reviewer = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.locationId = locationId;
            this.locationName = locationName;
            this.shiftId = shiftId;
            this.shiftName = shiftName;
            this.furnaceId = furnaceId;
            this.furnaceName = furnaceName;
            this.feed1 = feed1;
            this.feed2 = feed2;
            this.feed3 = feed3;
            this.feed4 = feed4;
            this.feed5 = feed5;
            this.feed6 = feed6;
            this.feed7 = feed7;
            this.feed8 = feed8;
            this.feed9 = feed9;
            this.shiftTotal = shiftTotal;
            this.dailyTotal = dailyTotal;
            this.tubeTotal = tubeTotal;
            this.beltWeigherNumber = beltWeigherNumber;
            this.recordTime = recordTime;
            this.recorderId = recorderId;
            this.recorder = recorder;
            this.reviewerId = reviewerId;
            this.reviewer = reviewer;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdSmeltingPelletFeeding();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.locationId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'shiftId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.shiftId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'shiftName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.shiftName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.furnaceId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.furnaceName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'feed1',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.feed1',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'feed2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.feed2',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'feed3',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.feed3',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'feed4',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.feed4',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'feed5',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.feed5',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'feed6',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.feed6',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'feed7',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.feed7',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'feed8',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.feed8',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'feed9',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.feed9',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'shiftTotal',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.shiftTotal',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'dailyTotal',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.dailyTotal',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'tubeTotal',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.tubeTotal',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'beltWeigherNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.beltWeigherNumber',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.recordTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recorderId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.recorderId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recorder',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.recorder',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'reviewerId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.reviewerId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'reviewer',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.reviewer',
                sortable: true,
                isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            locationIdFilter : '',
            locationNameFilter : '',
            shiftIdFilter : '',
            shiftNameFilter : '',
            furnaceIdFilter : '',
            furnaceNameFilter : '',
            feed1Filter : '',
            feed2Filter : '',
            feed3Filter : '',
            feed4Filter : '',
            feed5Filter : '',
            feed6Filter : '',
            feed7Filter : '',
            feed8Filter : '',
            feed9Filter : '',
            shiftTotalFilter : '',
            dailyTotalFilter : '',
            tubeTotalFilter : '',
            beltWeigherNumberFilter : '',
            recordTimeRteFilter : '',
            recordTimeLteFilter : '',
            recorderIdFilter : '',
            recorderFilter : '',
            reviewerIdFilter : '',
            reviewerFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'shiftNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.filter.shiftName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstShift'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"shiftId":"id"}'
                        }
                },
                {
                key: 'furnaceNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.filter.furnaceName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'feed1Filter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.filter.feed1',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'feed2Filter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.filter.feed2',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'feed3Filter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.filter.feed3',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'feed4Filter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.filter.feed4',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'feed5Filter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.filter.feed5',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'feed6Filter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.filter.feed6',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'feed7Filter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.filter.feed7',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'feed8Filter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.filter.feed8',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'feed9Filter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.filter.feed9',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'shiftTotalFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.filter.shiftTotal',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'dailyTotalFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.filter.dailyTotal',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'tubeTotalFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.filter.tubeTotal',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'beltWeigherNumberFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.filter.beltWeigherNumber',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'recordTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.filter.recordTimeRte',
                disabled: false,
                form: {
                type: 'datepicker'
                        }
                },
                {
                key: 'recordTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.filter.recordTimeLte',
                disabled: false,
                form: {
                type: 'datepicker'
                        }
                },
                {
                key: 'recorderFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.filter.recorder',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                        }
                },
                // {
                // key: 'reviewerFilter',
                // label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.filter.reviewer',
                // disabled: false,
                // form: {
                // type: 'entityModalSelect'
                //     ,entity: 'emAclUser'
                //     ,correspondingField: 'name'
                //     ,fieldsBindingByEntityModalSelected: '{"reviewerId":"id"}'
                //         }
                // }
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'shiftName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.entity.shiftName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'imfMstShift'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"shiftId":"id"}'
                        }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.entity.furnaceName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'feed1',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.entity.feed1',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'feed2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.entity.feed2',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'feed3',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.entity.feed3',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'feed4',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.entity.feed4',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'feed5',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.entity.feed5',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'feed6',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.entity.feed6',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'feed7',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.entity.feed7',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'feed8',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.entity.feed8',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'feed9',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.entity.feed9',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'shiftTotal',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.entity.shiftTotal',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'dailyTotal',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.entity.dailyTotal',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'tubeTotal',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.entity.tubeTotal',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'beltWeigherNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.entity.beltWeigherNumber',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.entity.recordTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datepicker'
                        }
                },
                {
                key: 'recorder',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.entity.recorder',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                        }
                },
                // {
                // key: 'reviewer',
                // label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.entity.reviewer',
                // sortable: true,
                // disabled: false,
                // form: {
                // type: 'entityModalSelect'
                //     ,entity: 'emAclUser'
                //     ,correspondingField: 'name'
                //     ,fieldsBindingByEntityModalSelected: '{"reviewerId":"id"}'
                //         }
                // },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPelletFeeding.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdSmeltingPelletFeeding, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        